
import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_6515_19337)">
      <path d="M14.1399 10.5934C13.7158 11.5964 13.0525 12.4802 12.2079 13.1676C11.3633 13.855 10.3631 14.325 9.2949 14.5366C8.22668 14.7481 7.12289 14.6948 6.08004 14.3813C5.03719 14.0677 4.08703 13.5034 3.31262 12.7378C2.53822 11.9722 1.96315 11.0286 1.6377 9.98935C1.31225 8.95015 1.24632 7.84704 1.44568 6.77647C1.64503 5.70591 2.10361 4.70047 2.78131 3.84807C3.45901 2.99567 4.3352 2.32226 5.33328 1.88672"
        stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.6667 8.00016C14.6667 7.12468 14.4942 6.25778 14.1592 5.44894C13.8242 4.6401 13.3331 3.90517 12.714 3.28612C12.095 2.66706 11.3601 2.176 10.5512 1.84097C9.74239 1.50593 8.87548 1.3335 8 1.3335V8.00016H14.6667Z"
        stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_6515_19337">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>

);


export default Icon
